import { IoAdd } from 'react-icons/io5';
import { MdLogout } from 'react-icons/md';
import { FiUserPlus } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { userShape } from './ThreadItem';
import { asyncUnsetAuthUser } from '../states/auth/actions';

const TopNavbar = ({ authUser }) => {
  const dispatch = useDispatch();
  const onLogout = () => {
    dispatch(asyncUnsetAuthUser());
  };

  const navigate = useNavigate();
  return (
    <header className="sticky top-0 w-full bg-[hsl(27,90%,98%)] border-b border-[#EAEAEA] z-40">
      <nav className="max-w-9xl mx-auto px-6 py-[23px] xl:px-[40px] flex justify-between items-center">
        <Link to="/">
          <span className="text-xl font-black">
            thread
            <span className="text-[#F48023]">
              Nvote
            </span>
          </span>
        </Link>
        {authUser ? (
          <div className="flex gap-4 justify-center items-center">
            <button type="button" className="p-1 rounded-md sm:rounded-md sm:pr-5 sm:pl-4 sm:py-3 bg-[#F48023] text-xs font-semibold text-white flex justify-between items-center gap-2" onClick={() => navigate('/threads/new')} title="Create a Thread">
              <IoAdd className="text-3xl sm:text-base" />
              <span className="hidden sm:block">
                Create a Thread
              </span>
            </button>
            <div className="flex justify-center items-center gap-3">
              <img src={authUser.avatar} alt={`${authUser.name} avatar`} className="w-[38px] rounded-full" title={`${authUser.name} avatar`} />
              <button type="button" onClick={onLogout} aria-label="logout" title="Log Out" data-cy="logout-button"><MdLogout /></button>
            </div>
          </div>
        ) : (
          <div className="flex gap-4">
            <Link className="px-5 py-3 rounded-md bg-[#F48023] text-xs font-black text-white tracking-[0.02em] font-roboto flex justify-between items-center gap-3" to="/register">
              <FiUserPlus fontSize={13} />
              <span>
                Register
              </span>
            </Link>
            <Link
              className="hidden sm:block px-5 py-3 rounded-md bg-[#EAEAEA] text-xs font-black text-[#1682FD] tracking-[0.02em
        ] font-roboto"
              to="/login"
            >
              Login
            </Link>
          </div>
        )}

      </nav>
    </header>
  );
};

TopNavbar.propTypes = {
  /** The identity of auth user */
  authUser: PropTypes.shape(userShape),
};

TopNavbar.defaultProps = {
  authUser: null,
};

export default TopNavbar;
